import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { MLRadioContext } from './MLRadio';

import s from './MLRadio.module.css';

const MLRadioButton = ({
  name,
  disabled,
  text,
  subText,
  textClass,
  subTextClass,
  className = '',
  inputClassName = '',
  testId,
  children,
  value,
  dataId,
}) => {
  const subTextRender = (
    <span className={subTextClass || s.subText}> {subText} </span>
  );
  const context = useContext(MLRadioContext);
  const radioId = uuidv4();

  return (
    <label
      className={`${s.radio} ${className}`}
      htmlFor={radioId}
      data-test-id={testId}
      data-id={dataId}
    >
      <input
        className={`${s.radioInput} ${inputClassName}`}
        id={radioId}
        name={name}
        disabled={disabled}
        checked={value === context.selectedValue}
        type="radio"
        data-test-id={`${testId}_radio_input`}
        data-id={dataId && `${dataId}_input`}
        onChange={(e) => {
          context.onChange(e, value);
        }}
      />
      {text && <span className={textClass}>{text}</span>}
      {text && subText && <br />}
      {subText && subTextRender}
      {children}
    </label>
  );
};

MLRadioButton.propTypes = {
  value: PropTypes.any.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subText: PropTypes.string,
  textClass: PropTypes.string,
  subTextClass: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  testId: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default MLRadioButton;
